export default __webpack_public_path__ + "tab2_video_poster5527ff.png";